import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';

const MovimentosSidebar = ({ onOptionChange }) => {
    const items = [
        {
            label: 'Movimentos',
            icon: 'pi pi-exchange',
            items: [
                {
                    label: 'De entrada',
                    icon: 'pi pi-sign-in',
                    command: () => onOptionChange('movEntrada')
                },
                {
                    label: 'De saída',
                    icon: 'pi pi-sign-out',
                    command: () => onOptionChange('movSaida')
                },
                {
                    label: 'Movimentos por',
                    icon: 'pi pi-filter',
                    items: [
                        {
                            label: 'Data',
                            icon: 'pi pi-calendar',
                            command: () => onOptionChange('movPorData')
                        },
                        {
                            label: 'Cliente',
                            icon: 'pi pi-user',
                            command: () => onOptionChange('movPorCliente')
                        },
                        {
                            label: 'Fornecedor',
                            icon: 'pi pi-briefcase',
                            command: () => onOptionChange('movPorFornecedor')
                        },
                        {
                            label: 'Famílias',
                            icon: 'pi pi-tags',
                            command: () => onOptionChange('movPorFamilias')
                        }
                    ]
                }
            ]
        }
    ];

    return (
        <div className="p-3">
            <PanelMenu model={items} style={{ width: '100%' }} />
        </div>
    );
};

export default MovimentosSidebar;
